import React from "react";
import { Icon, IconButton, MenuItem, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, TextField, Switch } from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";
import { FieldArray } from "formik";
import DataTableHeadCell from "examples/Tables/DataTable/DataTableHeadCell";
import { maskDdd, maskPhone } from "utils/Functions";

export default function DevedorTelefoneSection({ values, setFieldValue, handleChange, isViewOnly, apenasValidos = true }) {
    const visibleTelefones = values.telefones.filter(item => !(apenasValidos && (item.cbRuim || item.cbBlackList)));
    const hiddenCount = values.telefones.length - visibleTelefones.length;

    return (
        <MDBox mt={2}>
            <FieldArray name="telefones">
                {({ push, remove }) => (
                    <>
                        <MDBox display="flex" justifyContent="space-between" alignItems="center" mb={1} flexWrap="wrap" gap={1}>
                            <MDBox display="flex" alignItems="center" gap={1}>
                                <MDTypography variant="button" fontWeight="bold" color="text">
                                    TELEFONES ({visibleTelefones.length}{hiddenCount > 0 ? ` de ${values.telefones.length}` : ""})
                                </MDTypography>
                                {hiddenCount > 0 && apenasValidos && (
                                    <MDTypography variant="caption" color="warning" sx={{ fontSize: "0.75rem", fontWeight: "bold" }}>
                                        ({hiddenCount} inválido{hiddenCount > 1 ? "s" : ""} oculto{hiddenCount > 1 ? "s" : ""})
                                    </MDTypography>
                                )}
                            </MDBox>
                            <MDButton variant="contained" color="info" size="small" onClick={() => push({ ccDdd: '', ccTelefone: '', cvTipo: 2, cvOrigem: 4, ccContato: '', cbRuim: false, cbBlackList: false })}>
                                <Icon sx={{ mr: 0.5 }}>add</Icon> Adicionar Telefone
                            </MDButton>
                        </MDBox>
                        {values.telefones.length > 0 && (
                            <TableContainer sx={{ boxShadow: "none" }}>
                                <Table>
                                    <MDBox component="thead">
                                        <TableRow>
                                            <DataTableHeadCell width="8%" sorted={false}>DDD</DataTableHeadCell>
                                            <DataTableHeadCell width="20%" sorted={false}>TELEFONE</DataTableHeadCell>
                                            <DataTableHeadCell width="14%" sorted={false}>TIPO</DataTableHeadCell>
                                            <DataTableHeadCell width="16%" sorted={false}>ORIGEM</DataTableHeadCell>
                                            <DataTableHeadCell width="18%" sorted={false}>CONTATO</DataTableHeadCell>
                                            <DataTableHeadCell width="8%" align="center" sorted={false}>RUIM</DataTableHeadCell>
                                            <DataTableHeadCell width="8%" align="center" sorted={false}>BLACKLIST</DataTableHeadCell>
                                            <DataTableHeadCell width="8%" align="center" sorted={false}>AÇÕES</DataTableHeadCell>
                                        </TableRow>
                                    </MDBox>
                                    <TableBody>
                                        {values.telefones.map((item, index) => {
                                            const isInvalid = Boolean(item.cbRuim || item.cbBlackList);
                                            if (apenasValidos && isInvalid) return null;

                                            return (
                                                <TableRow key={index} sx={isInvalid ? { opacity: 0.6 } : {}}>
                                                    <TableCell sx={{ py: 1, px: 1, verticalAlign: "top", pt: 1.5 }}>
                                                        <MDInput 
                                                            fullWidth 
                                                            size="small"
                                                            name={`telefones[${index}].ccDdd`}
                                                            value={maskDdd(values.telefones[index].ccDdd || '')} 
                                                            onChange={(e) => setFieldValue(`telefones[${index}].ccDdd`, maskDdd(e.target.value))} 
                                                            placeholder="00"
                                                        />
                                                    </TableCell>
                                                    <TableCell sx={{ py: 1, px: 1, verticalAlign: "top", pt: 1.5 }}>
                                                        <MDInput 
                                                            fullWidth 
                                                            size="small"
                                                            name={`telefones[${index}].ccTelefone`}
                                                            value={maskPhone(values.telefones[index].ccTelefone || '')} 
                                                            onChange={(e) => setFieldValue(`telefones[${index}].ccTelefone`, maskPhone(e.target.value))} 
                                                            placeholder="00000-0000"
                                                        />
                                                    </TableCell>
                                                    <TableCell sx={{ py: 1, px: 1, verticalAlign: "top", pt: 1.5 }}>
                                                        <MDInput 
                                                            select 
                                                            fullWidth 
                                                            size="small"
                                                            name={`telefones[${index}].cvTipo`}
                                                            value={values.telefones[index].cvTipo} 
                                                            onChange={handleChange}
                                                        >
                                                            <MenuItem value={1}>Fixo</MenuItem>
                                                            <MenuItem value={2}>Celular</MenuItem>
                                                            <MenuItem value={3}>WhatsApp</MenuItem>
                                                        </MDInput>
                                                    </TableCell>
                                                    <TableCell sx={{ py: 1, px: 1, verticalAlign: "top", pt: 1.5 }}>
                                                        <MDInput 
                                                            select 
                                                            fullWidth 
                                                            size="small"
                                                            name={`telefones[${index}].cvOrigem`}
                                                            value={values.telefones[index].cvOrigem} 
                                                            onChange={handleChange}
                                                        >
                                                            <MenuItem value={1}>Serasa</MenuItem>
                                                            <MenuItem value={2}>Boa Vista</MenuItem>
                                                            <MenuItem value={3}>Cliente</MenuItem>
                                                            <MenuItem value={4}>Informado</MenuItem>
                                                            <MenuItem value={5}>Outros</MenuItem>
                                                            <MenuItem value={6}>Remessa</MenuItem>
                                                        </MDInput>
                                                    </TableCell>
                                                    <TableCell sx={{ py: 1, px: 1, verticalAlign: "top", pt: 1.5 }}>
                                                        <MDInput 
                                                            fullWidth 
                                                            size="small"
                                                            name={`telefones[${index}].ccContato`}
                                                            value={values.telefones[index].ccContato} 
                                                            onChange={handleChange} 
                                                            placeholder="Falar com..."
                                                        />
                                                    </TableCell>
                                                    <TableCell align="center" sx={{ py: 1, px: 1, verticalAlign: "top", pt: 1.5 }}>
                                                        <MDBox display="flex" justifyContent="center" pt={0.3}>
                                                            <Switch 
                                                                checked={values.telefones[index].cbRuim} 
                                                                onChange={(e) => setFieldValue(`telefones[${index}].cbRuim`, e.target.checked)} 
                                                            />
                                                        </MDBox>
                                                    </TableCell>
                                                    <TableCell align="center" sx={{ py: 1, px: 1, verticalAlign: "top", pt: 1.5 }}>
                                                        <MDBox display="flex" justifyContent="center" pt={0.3}>
                                                            <Switch 
                                                                checked={values.telefones[index].cbBlackList} 
                                                                onChange={(e) => setFieldValue(`telefones[${index}].cbBlackList`, e.target.checked)} 
                                                                color="error" 
                                                            />
                                                        </MDBox>
                                                    </TableCell>
                                                    <TableCell align="center" sx={{ py: 1, px: 1, verticalAlign: "top", pt: 1.5 }}>
                                                        <MDBox display="flex" justifyContent="center" pt={0.3}>
                                                            <IconButton color="error" size="small" onClick={() => remove(index)}>
                                                                <Icon>delete</Icon>
                                                            </IconButton>
                                                        </MDBox>
                                                    </TableCell>
                                                </TableRow>
                                            );
                                        })}
                                        {values.telefones.length > 0 && visibleTelefones.length === 0 && (
                                            <TableRow>
                                                <TableCell colSpan={8} align="center" sx={{ py: 2 }}>
                                                    <MDTypography variant="caption" color="text">
                                                        Todos os {values.telefones.length} telefones cadastrados estão marcados como Ruim ou Blacklist (ocultos pelo filtro).
                                                    </MDTypography>
                                                </TableCell>
                                            </TableRow>
                                        )}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        )}
                    </>
                )}
            </FieldArray>
        </MDBox>
    );
}
